
const productElementApi = {

    async getElementGroup(quoteId, customGroupId){
        const results = await fetch(window.location.origin + '/api/v1/configurator/quotes/'+ quoteId + '/element_groups/' +customGroupId)
            .then(results => {
                return results.json();
            }).catch(function() {
                return false;
            })
        return results;
    },
};

export default productElementApi;